import * as React from "react";
import type { SVGProps } from "react";
const SvgAlarm03 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M9.707 11.893a1 1 0 0 0-1.414 1.414L9 12.6zM10.8 14.4l-.707.707a1 1 0 0 0 1.414 0zm4.907-3.493a1 1 0 0 0-1.414-1.414L15 10.2zM6.563 19.62a1 1 0 1 0-1.414-1.414l.707.707zm-4.102 1.274a1 1 0 1 0 1.414 1.414l-.707-.707zm17.664 1.414a1 1 0 0 0 1.414-1.414l-.707.707zm-1.274-4.102a1 1 0 0 0-1.414 1.414l.707-.707zM5.507 3.107a1 1 0 0 0-1.414-1.414L4.8 2.4zM1.093 4.693a1 1 0 0 0 1.414 1.414L1.8 5.4zm20.4 1.414a1 1 0 1 0 1.414-1.414L22.2 5.4zm-1.586-4.414a1 1 0 1 0-1.414 1.414L19.2 2.4zM9 12.6l-.707.707 1.8 1.8.707-.707.707-.707-1.8-1.8zm1.8 1.8.707.707 4.2-4.2L15 10.2l-.707-.707-4.2 4.2zm-4.944 4.512-.707-.707-2.688 2.688.707.707.707.707 2.688-2.688zM20.832 21.6l.707-.707-2.688-2.688-.707.707-.707.707 2.688 2.688zm-.384-8.832h-1A7.45 7.45 0 0 1 12 20.216v2a9.45 9.45 0 0 0 9.448-9.448zM12 21.216v-1a7.45 7.45 0 0 1-7.448-7.448h-2A9.45 9.45 0 0 0 12 22.216zm-8.448-8.448h1A7.45 7.45 0 0 1 12 5.32v-2a9.45 9.45 0 0 0-9.448 9.448zM12 4.32v1a7.45 7.45 0 0 1 7.448 7.448h2A9.45 9.45 0 0 0 12 3.32zM4.8 2.4l-.707-.707-3 3L1.8 5.4l.707.707 3-3zm17.4 3 .707-.707-3-3-.707.707-.707.707 3 3z"
    />
  </svg>
);
export default SvgAlarm03;
